<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Dispositivos
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
          v-card-title(style='padding: 8px !important;').justify-center
            img(src='../assets/logo.png', style='height: auto;width: 80px;border-radius:5px')
        v-card(color='', style="border-radius:5px;background-color: black")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text  Control de Dispositivos

    v-layout(align-start='', justify-start='', row='', fill-height='', style='margin-top:10px;')
      v-flex(xs12, md6, sm12, style='padding-right:8px;')
        v-card(style='border-radius:8px;padding:16px;')
          v-card-title(style='padding:0 0 12px;font-size:15px;font-weight:bold;') Configuración global
          v-layout(row wrap)
            v-flex(xs12)
              v-switch(v-model='settings.dispositivo_activo_por_defecto' label='Nuevos dispositivos activos por defecto' color='#222C59')
            v-flex(xs12 sm6 style='padding-right:8px;')
              v-text-field(outline v-model='settings.version_minima' label='Versión mínima requerida' prepend-inner-icon='system_update')
            v-flex(xs12 sm6)
              v-text-field(outline v-model='settings.version_ultima' label='Última versión disponible' prepend-inner-icon='new_releases')
            v-flex(xs12)
              v-btn(style='background:#222C59;color:white;border-radius:8px;' @click='saveSettings') Guardar configuración

    v-layout(align-start='', justify-start='', row='', fill-height='', style='margin-top:10px;')
      v-flex(xs12)
        v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text Dispositivos de Vendedores
        v-card(style='border-radius:0 0 8px 8px;')
          div(v-if='loadingVend' style='text-align:center;padding:24px;')
            v-progress-circular(indeterminate color='#222C59')
          div(v-else)
            div(v-for='vend in vendedores' :key='vend._id' style='border-bottom:1px solid #eee;padding:12px 16px;')
              div(style='display:flex;align-items:center;gap:8px;margin-bottom:8px;')
                v-icon(color='#222C59') person
                span(style='font-weight:bold;font-size:15px;') {{ vend.ven_des }} ({{ vend.co_ven.trim() }})
                v-chip(small :color='vend.version_app && vend.version_app !== "—" ? "#4caf50" : "#9e9e9e"' text-color='white' style='margin-left:8px;') v{{ vend.version_app }}
              div(v-for='disp in vend.dispositivos' :key='disp.device_id' style='background:#f9f9f9;border-radius:8px;padding:10px 14px;margin-bottom:6px;display:flex;align-items:center;gap:8px;flex-wrap:wrap;')
                v-icon(:color='disp.platform === "android" ? "#4caf50" : "#555"' style='min-width:24px;') {{ disp.platform === "ios" ? "phone_iphone" : "phone_android" }}
                div(style='flex:1;min-width:180px;')
                  div(style='font-size:13px;font-weight:500;') {{ disp.alias || disp.modelo || disp.device_id }}
                  div(style='font-size:11px;color:#888;')
                    span {{ disp.modelo || '—' }}
                    span(v-if='disp.ram')  · {{ disp.ram }}
                    span(v-if='disp.almacenamiento')  · {{ disp.almacenamiento }}
                  div(style='font-size:11px;color:#aaa;') ID: {{ disp.device_id }}
                  div(style='font-size:11px;color:#aaa;') Registrado: {{ formatFecha(disp.fecha_registro) }}
                v-chip(small :color='disp.activo ? "#4caf50" : "#f44336"' text-color='white') {{ disp.activo ? "Activo" : "Bloqueado" }}
                v-btn(icon small @click='editarAlias(disp)')
                  v-icon(small color='#666') edit
                v-btn(icon small @click='toggleDispVend(vend, disp)')
                  v-icon(small :color='disp.activo ? "#f44336" : "#4caf50"') {{ disp.activo ? "block" : "check_circle" }}
                v-btn(icon small @click='eliminarDispVend(vend, disp)')
                  v-icon(small color='pink') delete

    v-layout(align-start='', justify-start='', row='', fill-height='', style='margin-top:10px;')
      v-flex(xs12)
        v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:#222C59;")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text Dispositivos de Supervisores
        v-card(style='border-radius:0 0 8px 8px;')
          div(v-if='loadingUsus' style='text-align:center;padding:24px;')
            v-progress-circular(indeterminate color='#222C59')
          div(v-else)
            div(v-for='usu in supervisores' :key='usu._id' style='border-bottom:1px solid #eee;padding:12px 16px;')
              div(style='display:flex;align-items:center;gap:8px;margin-bottom:8px;')
                v-icon(color='#222C59') manage_accounts
                span(style='font-weight:bold;font-size:15px;') {{ usu.nombre }} {{ usu.apellido }}
                span(style='font-size:12px;color:#888;margin-left:4px;') {{ usu.email }}
              div(v-for='disp in usu.dispositivos' :key='disp.device_id' style='background:#f9f9f9;border-radius:8px;padding:10px 14px;margin-bottom:6px;display:flex;align-items:center;gap:8px;flex-wrap:wrap;')
                v-icon(:color='disp.platform === "android" ? "#4caf50" : "#555"' style='min-width:24px;') {{ disp.platform === "ios" ? "phone_iphone" : "phone_android" }}
                div(style='flex:1;min-width:180px;')
                  div(style='font-size:13px;font-weight:500;') {{ disp.alias || disp.modelo || disp.device_id }}
                  div(style='font-size:11px;color:#888;')
                    span {{ disp.modelo || '—' }}
                    span(v-if='disp.ram')  · {{ disp.ram }}
                  div(style='font-size:11px;color:#aaa;') ID: {{ disp.device_id }}
                  div(style='font-size:11px;color:#aaa;') Registrado: {{ formatFecha(disp.fecha_registro) }}
                v-chip(small :color='disp.activo ? "#4caf50" : "#f44336"' text-color='white') {{ disp.activo ? "Activo" : "Bloqueado" }}
                v-btn(icon small @click='editarAlias(disp)')
                  v-icon(small color='#666') edit
                v-btn(icon small @click='toggleDispUsu(usu, disp)')
                  v-icon(small :color='disp.activo ? "#f44336" : "#4caf50"') {{ disp.activo ? "block" : "check_circle" }}
                v-btn(icon small @click='eliminarDispUsu(usu, disp)')
                  v-icon(small color='pink') delete

  v-dialog(v-model='dialogAlias' max-width='400px')
    v-card
      v-card-title(style='background:#222C59;')
        span(style='color:white;') Editar alias del dispositivo
      v-card-text(style='padding:16px;')
        v-text-field(outline v-model='aliasForm.alias' label='Alias (nombre amigable)' prepend-inner-icon='label')
        div(style='font-size:11px;color:#aaa;') ID: {{ aliasForm.device_id }}
      v-card-actions
        v-spacer
        v-btn(flat @click='dialogAlias = false') Cancelar
        v-btn(style='background:#222C59;color:white;border-radius:8px;' @click='saveAlias') Guardar
</template>

<script>
import Api from "@/services/methods";
export default {
  name: "mDispositivos",
  data: () => ({
    vendedores: [],
    supervisores: [],
    loadingVend: false,
    loadingUsus: false,
    settings: {
      dispositivo_activo_por_defecto: true,
      version_minima: '1.0.0',
      version_ultima: '1.0.0',
    },
    settingsId: null,
    dialogAlias: false,
    aliasForm: { device_id: '', alias: '' },
  }),
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.loadSettings();
      this.loadVendedores();
      this.loadSupervisores();
    },
    loadSettings() {
      Api.get('settings').then(res => {
        if (res.data && res.data.length > 0) {
          const s = res.data[0];
          this.settingsId = s._id;
          this.settings.dispositivo_activo_por_defecto = s.dispositivo_activo_por_defecto !== false;
          this.settings.version_minima = s.version_minima || '1.0.0';
          this.settings.version_ultima = s.version_ultima || '1.0.0';
        }
      });
    },
    saveSettings() {
      const payload = {
        dispositivo_activo_por_defecto: this.settings.dispositivo_activo_por_defecto,
        version_minima: this.settings.version_minima,
        version_ultima: this.settings.version_ultima,
      };
      if (this.settingsId) {
        payload._id = this.settingsId;
        Api.put('settings', payload).then(() => {
          this.$swal.fire('Guardado', 'Configuración actualizada.', 'success');
        }).catch(err => {
          console.error(err);
          this.$swal.fire('Error', 'No se pudo guardar la configuración.', 'error');
        });
      } else {
        Api.post('settings', payload).then(res => {
          this.settingsId = res.data._id;
          this.$swal.fire('Guardado', 'Configuración creada exitosamente.', 'success');
        }).catch(err => {
          console.error(err);
          this.$swal.fire('Error', 'No se pudo guardar la configuración.', 'error');
        });
      }
    },
    loadVendedores() {
      this.loadingVend = true;
      Api.get('vendedor/dispositivos').then(res => {
        this.vendedores = res.data || [];
        this.loadingVend = false;
      }).catch(() => { this.loadingVend = false; });
    },
    loadSupervisores() {
      this.loadingUsus = true;
      Api.get('usuario/dispositivos').then(res => {
        this.supervisores = res.data || [];
        this.loadingUsus = false;
      }).catch(() => { this.loadingUsus = false; });
    },
    formatFecha(fecha) {
      if (!fecha) return '—';
      return new Date(fecha).toLocaleDateString('es-VE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
    },
    editarAlias(disp) {
      this.aliasForm = { device_id: disp.device_id, alias: disp.alias || '' };
      this.dialogAlias = true;
    },
    saveAlias() {
      Api.put('dispositivoAlias', { device_id: this.aliasForm.device_id, alias: this.aliasForm.alias }).then(() => {
        this.dialogAlias = false;
        this.loadVendedores();
        this.loadSupervisores();
      });
    },
    toggleDispVend(vend, disp) {
      const msg = disp.activo ? 'bloquear' : 'activar';
      this.$swal.fire({ title: `¿Desea ${msg} este dispositivo?`, type: 'warning', showCancelButton: true, confirmButtonText: 'Sí', cancelButtonText: 'No' }).then(r => {
        if (r.value) {
          Api.put('vendedor/dispositivo', { co_ven: vend.co_ven, device_id: disp.device_id, activo: !disp.activo }).then(() => {
            this.loadVendedores();
          });
        }
      });
    },
    eliminarDispVend(vend, disp) {
      this.$swal.fire({ title: '¿Eliminar dispositivo?', type: 'warning', showCancelButton: true, confirmButtonText: 'Sí, eliminar', cancelButtonText: 'No' }).then(r => {
        if (r.value) {
          Api.deleteWithBody('vendedor/dispositivo', { co_ven: vend.co_ven, device_id: disp.device_id }).then(() => {
            this.loadVendedores();
          });
        }
      });
    },
    toggleDispUsu(usu, disp) {
      const msg = disp.activo ? 'bloquear' : 'activar';
      this.$swal.fire({ title: `¿Desea ${msg} este dispositivo?`, type: 'warning', showCancelButton: true, confirmButtonText: 'Sí', cancelButtonText: 'No' }).then(r => {
        if (r.value) {
          Api.put('usuario/dispositivo', { _id: usu._id, device_id: disp.device_id, activo: !disp.activo }).then(() => {
            this.loadSupervisores();
          });
        }
      });
    },
    eliminarDispUsu(usu, disp) {
      this.$swal.fire({ title: '¿Eliminar dispositivo?', type: 'warning', showCancelButton: true, confirmButtonText: 'Sí, eliminar', cancelButtonText: 'No' }).then(r => {
        if (r.value) {
          Api.deleteWithBody('usuario/dispositivo', { _id: usu._id, device_id: disp.device_id }).then(() => {
            this.loadSupervisores();
          });
        }
      });
    },
  }
};
</script>
<style lang="scss"></style>
